(ns reagent-material-ui.icons.indeterminate-check-box-outlined
  "Imports @material-ui/icons/IndeterminateCheckBoxOutlined as a Reagent component."
  (:require-macros [reagent-material-ui.util :refer [create-svg-icon e]])
  (:require [react :as react]
            ["@material-ui/core/SvgIcon" :as SvgIcon]
            [reagent-material-ui.util]))

(def indeterminate-check-box-outlined (create-svg-icon (e "path" #js {"d" "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7 11h10v2H7z"})
                                                       "IndeterminateCheckBoxOutlined"))
